import { Button } from "@babackapp/customer-ui/components/button";
import type { ReactNode } from "react";

type Props = {
  icon: ReactNode;
  title: string;
  description: string;
  ctaLabel: string;
  onCta: () => void;
};

export function EmptyState({ icon, title, description, ctaLabel, onCta }: Props) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-lg border border-dashed py-10 px-6 text-center">
      <div className="flex size-10 items-center justify-center rounded-full bg-muted text-muted-foreground">
        {icon}
      </div>
      <div className="flex flex-col gap-1">
        <p className="text-sm font-medium text-foreground">{title}</p>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
      <Button variant="secondary" type="button" onClick={onCta}>
        {ctaLabel}
      </Button>
    </div>
  );
}
